import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'
import { tv, VariantProps } from 'tailwind-variants'

import stamp from '@/assets/stamps/stamp.webp'
import stampRegeneration from '@/assets/stamps/stamp-regeneration.webp'
import { getYearFromBack } from '@/helper/time'
import { Selos } from '@/models/user'

const imageStyles = tv({
  variants: {
    variant: {
      viewProperty: 'h-full',
      queryProperty: 'w-36 object-cover',
    },
  },
  defaultVariants: {
    variant: 'viewProperty',
  },
})

const colorsStyles = tv({
  variants: {
    colors: {
      R: 'bg-stamp-regeneration',
      P: 'bg-white',
      A: 'bg-white',
      M: '',
    },
  },
  defaultVariants: {
    colors: 'P',
  },
})

const sizeStyles = tv({
  variants: {
    size: {
      normal: 'text-base',
      large: 'text-xl 2xl:text-2xl',
    },
  },
  defaultVariants: {
    size: 'normal',
  },
})

interface StampProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof imageStyles>,
    VariantProps<typeof sizeStyles>,
    VariantProps<typeof colorsStyles> {
  typeConservation: Selos
  dateRegister: string
  isDateFormat?: boolean
}

export function Stamp({
  dateRegister,
  typeConservation,
  variant,
  colors,
  size,
  className,
  isDateFormat = true,
  ...rest
}: StampProps) {
  const stamps: Record<Selos, string> = {
    P: stamp,
    R: stampRegeneration,
    A: stamp, // TODO: Colocar uma stamp para esse tipo quando tiver e remover essa atual
    M: '',
  }

  if (typeConservation === 'M') return null

  return (
    <div className={twMerge('flex flex-col', className)} {...rest}>
      <img
        src={stamps[typeConservation]}
        alt=""
        className={imageStyles({ variant })}
      />
      <div
        className={twMerge(
          'flex items-center justify-center rounded-b-xl p-1 drop-shadow-sm',
          colorsStyles({ colors }),
        )}
      >
        <span
          className={twMerge(
            'font-bold text-bios-secondary',
            sizeStyles({ size }),
          )}
        >
          {isDateFormat ? getYearFromBack(dateRegister) : dateRegister}
        </span>
      </div>
    </div>
  )
}
